import {computed} from 'vue';
import {storeToRefs} from 'pinia';
import type {FeatureFlagId} from '../feature-flag.types';
import {useFeatureFlagsStore} from '../store/feature-flags.store';

export function useFeatureFlag(flagId: FeatureFlagId) {
    const {featureFlags} = storeToRefs(useFeatureFlagsStore());

    return computed(() => featureFlags.value[flagId] ?? false);
}
